// Role-based route files
import adminRoutes from "./routes/adminRoutes";
import profRoutes from "./routes/profRoutes";
import universityRoutes from "./routes/universityRoutes";
import studentRoutes from "./routes/studentRoutes";

// Function to get routes based on role
// Accepts a role string and returns the corresponding route config array.
export function getRoutesByRole(role) {
  switch (role) {
    case "admin":
      return adminRoutes;
    case "prof":
      return profRoutes;
    case "university":
    case "university_admin":
      return universityRoutes;
    case "student":
      return studentRoutes;
    default:
      return profRoutes; // fallback routes if role is undefined
  }
}

export default getRoutesByRole;
